import { BCMSRecord, BCMSStateManagerCRUD, BrandingImage, Link, StateManager, useBCMSContext, useParams, useStateManager } from "@bcm-dev/bcms-vite";
import WidgetContainer from 'components/shared/containers/WidgetContainer';
import React from 'react';

import UIToggle from 'components/ui/UIToggle';
import Classes, { Card, Transaction } from "model";
import { ImageAsset, SVGAsset } from 'res';
import "./styles.css";

export default function CardWidget(props) {
  const context = useBCMSContext();
  BCMSRecord.globalControllerFor(Classes, context);
  const data = { ...getDefaultData(useParams().cardID, props.inactiveClass, context), ...props.data ?? {} };
  const ui = { ...getDefaultUI(), ...props.ui ?? {} };

  const controller = (state, setState) => ({
    data: state.data,
    ui: state.ui,

    update: val => {
      const crud = BCMSStateManagerCRUD.init(state);
      crud.update([ "data", "card", "isOn" ], val);
      crud.submit(setState);

      BCMSRecord.batch([
        Card.update({ ...data.card.record, isOn: val })
      ], context, Classes);
    },
  });

  return (
    <StateManager state={ { data, ui } } controller={ controller }>
      <CardWidgetContent/>
    </StateManager>
  );
}

export const getDefaultData = (_cardID, _inactiveClass, controller) => {
  const inactiveClass = _inactiveClass ?? "";
  const defaultCard = controller.state.branding.options.include_debit_chw23  !== "false" ? "0" : "1";
  
  let cardID = _cardID ?? defaultCard;
  const creditCardOptionOn = controller.state.branding.options.include_credit_chw23 === "true";

  if(!creditCardOptionOn && cardID === "1") {
    cardID = "0";
  }

  const card = Card.initByID(cardID);

  return { 
    card,
    inactiveClass
  };
}

export const getDefaultUI = () => {

}

function CardWidgetContent(props) {
  const { data, update } = useStateManager();
  const inactiveClass = data.inactiveClass;
  const card = data.card;
  const cardID = card.id;
  const name = card.type ?? "[[Card Type]]";
  const number = card.maskedNumber ?? "[[Card Number]]";
  const headerText = name+" "+number;
  /*const inactiveClass = props.inactiveClass ?? "";
  const globalController = useBCMSContext();
  const defaultCard =   globalController.state.branding.options.include_debit_chw23  !== "false" ? "0" : "1";
  
  let cardID = useParams().cardID ?? defaultCard;
  const creditCardOptionOn = globalController.state.branding.options.include_credit_chw23 === "true";

  if(!creditCardOptionOn && cardID === "1") {
    cardID = "0";
  }

  BCMSRecord.globalControllerFor(Classes, globalController);

  const card = Card.initByID(cardID);
  const name = card.type ?? "[[Card Type]]";
  const number = card.maskedNumber ?? "[[Card Number]]";
  const headerText = name+" "+number;

  const onChange = value => {
    BCMSRecord.batch([
      Card.update({ ...card.record, isOn: value })
    ], globalController, Classes);
    console.log(card)
  }

  console.log(card, card.isOn)*/

  return(
    <WidgetContainer headerText={headerText} className={inactiveClass + " card-widget-container"}>
      <div className="image-container flex-container flex-horizontal align-center-container justify-center-container" data-point="selected_card">
        {<CardContainer id="CardNoDetails" />}

      {
        !card.active &&
        <div className="activate-card-container flex-container flex-horizontal all-center-container">
          <Link to={ `/home/activatecardverification/${ cardID }` } className="activate-card-button text-center">
            <b>Activate Card</b>
          </Link>
          <div className="activate-card-overlay"></div>
        </div>
      }
      
      </div>
      {/* <div className="flex-container flex-horizontal align-center-container switch-add-card-container"> */}
        {/* <SVGAsset id="" /> */}
        {/* Placeholder for Icon */}
        {/* <p className="icon set-width">A</p>
        <b className="set-width">Switch or Add Card</b> */}
      {/* </div> */}
      <div className="card-on-container flex-container flex-horizontal align-center-container space-between-container">
        <b className="flex-width">Card is { card.isOn ? "ON" : "OFF" }</b>
        {/* UIToggle will go here */}
        <UIToggle dataPoint="toggle_card" checked={ card.isOn } onChange={ update } />
      </div>
    </WidgetContainer>
  );
}

export function CardContainer(props) {
  const inactiveClass = props.inactiveClass ?? "";
  const globalController = useBCMSContext();
  const defaultCard =   globalController.state.branding.options.include_debit_chw23  !== "false" ? "0" : "1";
  let cardID = useParams().cardID ?? defaultCard;
  const creditCardOptionOn = globalController.state.branding.options.include_credit_chw23 === "true";

  if(!creditCardOptionOn && cardID === "1") {
    cardID = "0";
  }

  BCMSRecord.globalControllerFor([ Card, Transaction ], globalController);
  const card = Card.initByID(cardID);
  const name = card.type ?? "[[Card Type]]";
  const number = card.lastFour ?? "[[Card Number]]";
  const provider = card.type == "credit" ? globalController.state.branding.options.credit_provider_chw23 :  globalController.state.branding.options.debit_provider_chw23;
 
  const point = props.dataPoint ?? "";
  const showSecurityCode = props.showCode ?? false;
  // Creating points for captures, creating an object so there aren't empty data points
  const numPoint = point.length > 0 ? { "data-point" : `${ point }_Number` } : {};
  const expPoint = point.length > 0 ? { "data-point" : `${ point }_Exp` } : {};
  const codePoint = point.length > 0 ? { "data-point" : `${ point }_Code` } : {};
  const firstGroup =  showSecurityCode ? card.bySection[0]:"••••";
  const secondGroup =  showSecurityCode ? card.bySection[1]:"••••";
  const thirdGroup =  showSecurityCode ? card.bySection[2]:"••••";
 
  return (
    <div className="card-container">
      <div className="image-container card-image-container">
        {/* card background asset */}
        {card.type == "debit" && <BrandingImage id="dc_bgimage_chw23" className="cardbackground" alt="debit card background" />}
        {card.type == "credit" && <BrandingImage id="cc_bgimage_chw23" className="cardbackground" alt="credit card background" />}
      </div>
      <div className="card-details-container flex-container flex-vertical">
        <div className="flex-height fi-logo-container">
          <BrandingImage id="fi_logo_chw23" className="fi-logo" alt="Financial Institution Logo" />
        </div>
        <div className="flex-height card-number flex-container flex-horizontal align-center-container all-space-between-container">
          <span className="set-width">{firstGroup}</span>
          <span className="set-width">{secondGroup}</span>
          <span className="set-width">{thirdGroup}</span>
          <span className="last-four set-width" { ...numPoint }>{number}</span>
        </div>
        <div className="flex-height flex-container flex-horizontal align-center-container expire-code-container">
          <div className="flex-width expiration-date-container flex-container flex-horizontal align-center-container">
            <span className="label set-width">VALID THRU</span>
            <span className="date flex-width" { ...expPoint }>MM/YY</span>
          </div>
          {
            showSecurityCode && 
            <div className="flex-width">
              <div className="security-code-container flex-container flex-horizontal align-center-container">
                <span className="label set-width">SECURITY CODE</span>
                <span className="code flex-width" { ...codePoint }>123</span>
              </div>
            </div>
          }
        </div>
        <div className="flex-height cardholder-container flex-container flex-horizontal align-bottom-container">
          <span className="flex-width cardholder-name">CARDHOLDER</span>
          <div className="set-width provider-logo-container align-bottom-item">
            {provider == "Visa" && <ImageAsset id="VisaLogo" className="provider" alt="debit card provider" />}
            {provider == "Mastercard" && <ImageAsset id="MastercardLogo" className="provider" alt="credit card provider" />}
          </div>
        </div>
      </div>
    </div>
  );
}